module.exports = __webpack_public_path__ + "media/images/img-btn-engineer-2e1ba26a22052f83921675ce58b7bc57.svg";